import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import Header from "../../layout/header";
import { Box, Button, Stack, Typography } from "@mui/material";

import RepresentativeContent from "../../components/dashboard/representative-content";
import { BackArrowIcon } from "../../components/ui-elements/svg-icons";
import BadgeImage from "../../components/ui-elements/badge-image";
import { useLocation, useNavigate } from "react-router-dom";
import { useNotificationService } from "../../hooks/notification";
import { useQuery } from "@tanstack/react-query";
import { apiGetAccount } from "../../api/account";
import {
  RepresentativeAccountData,
  RepresentativeAccountDummyData,
} from "../../interface/representative";
import { SkeletonRepsAccountLoading } from "../../components/ui-elements/skeleton-loading";

const Representative: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { representative_id } = location.state || {};
  const { showNotification } = useNotificationService();
  const [reps_info, setReps_info] = useState<RepresentativeAccountData>(
    RepresentativeAccountDummyData
  );

  const { data, refetch, isLoading } = useQuery({
    queryKey: ["representative_account"],
    queryFn: async () => {
      const result = await apiGetAccount(Number(representative_id ?? 0));
      if (result.status === "error" && "details" in result) {
        showNotification(result.details, "error");
        return {};
      }
      if (result?.status === 200) {
        setReps_info(result.data);
      }
      return result?.data || RepresentativeAccountDummyData;
    },
  });

  return (
    <>
      {/* Header Menu */}
      <Box
        sx={{
          background: theme.palette.background.paper,
        }}
      >
        <Header scrollContainerId={"main-scroll-container"}>
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <Button onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </Button>
            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              {reps_info?.name}
            </Typography>
            <BadgeImage badge={2} />
          </Stack>
        </Header>
        {isLoading ? (
          <Box
            sx={{
              maxWidth: 605,
              mx: "auto",
              py: "80px",
            }}
          >
            <SkeletonRepsAccountLoading />
          </Box>
        ) : (
          <RepresentativeContent reps_info={reps_info}  />
        )}
      </Box>
    </>
  );
};

export default Representative;
